import { UserPreferencesProjectServiceHttpClient } from './httpClient';

const getBaseUrl = (projectId) => `/projects/${projectId}/UserSettings`;
export const GROUP_SETTING_KEY = 'AnalysesGroupByPreference';
export const SORT_SETTING_KEY = 'AnalysesSortByPreference';

export const getUserPreferences = async (projectId, key) => {
  const { data } = await UserPreferencesProjectServiceHttpClient.get(
    `${getBaseUrl(projectId)}`,
    { settingKey: key }
  );
  return data;
};

export const saveUserPreferences = async (projectId, key, value) => {
  const response = await UserPreferencesProjectServiceHttpClient.post(
    getBaseUrl(projectId),
    {
      projectId: +projectId,
      settingKey: key,
      settingValue: value,
    }
  );
  return response;
};
